// v2.0 - Full Width Version

// v1.1 make it more like insta, titok home page with grid, reel, etc

// ok v1 init
import React from 'react';
// import './CustomSlider-fullwidth.css'; // Importing the specific CSS file
import { FullWidthBgImage } from './FullWidthBgImage'; // Assuming this is needed
import './CustomSlider-fullwidth steller.css'; // Importing the specific CSS file
import CardIcon from './CardIcon'; // Import CardIcon

// Functional CustomSlider component - Full Width
const data = [ // Using the same data for now
  {
    title: "Milan",
    data:
      //"https://obj.tang17so82duytan.com/demo-map/hit output-1746108449623.mp4"
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg"
  },
  {
    title: "Hong Kong",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg"
  },
  {
    title: "Prague",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg"
  },
  {
    title: "Florence",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg"
  },
  {
    title: "Venice",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0449_venice_marianna-tomaselli_final_header-768x432.jpg"
  },
  {
    title: "Los Angeles",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/venice-beach_final-768x512.jpg"
  },
  {
    title: "Milan",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0444_city-header_milan_marianna-tomaselli-768x432.jpg"
  },
  {
    title: "Hong Kong",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0378_hong-kong_jisu-choi_final_header-1-768x512.jpg"
  },
  {
    title: "Prague",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/location-page-header-prague-greta-samuel-768x512.jpg"
  },
  {
    title: "Florence",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0440_florence_giordano-poloni_final_header-768x512.jpg"
  },
  {
    title: "Venice",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/ia_0449_venice_marianna-tomaselli_final_header-768x432.jpg"
  },
  {
    title: "Los Angeles",
    data:
      "https://cdn.theculturetrip.com/wp-content/uploads/2019/04/venice-beach_final-768x512.jpg"
  }
];

const CustomSliderFullwidth = () => {
  return (

    <div className="custom-slider-fullwidth"> {/* Updated class name */}
      {/* Example item structure, adjust as needed */}
      {data.map((item, index) => (
        <div
          key={index}
          className="bg-image-container-fullwidth" // Class controls most styles now
          style={{
            backgroundImage: `url(${item.data})`

          }}
        >

          <CardIcon />
          <div className="slider-label-fullwidth">{'Category'}</div>
          <div className="slider-body-fullwidth">{item.title}</div>

          {/* {item.data.endsWith('.mp44') ? (
        <video
          className="image-fullwidth"
          src={item.data}
          autoPlay
          muted
          loop
          playsInline
        />
      ) : (
        <img
          style={{
            backgroundImage: `url(${item.data})`
          }}
          src={item.data} alt={item.title} className="image-fullwidth"
        />
      )}
      <CardIcon />
      <div className="slider-label-fullwidth">{'Category'}</div>
      <div className="slider-body-fullwidth">{item.title}</div> */}
        </div>
      ))}
    </div>

  )

};

export default CustomSliderFullwidth;
